export default {
  otherService: 'icon-other-filled',
  service_test: 'icon-other-filled',
  service_compute: 'icon-cpu-filled',
  service_storage: 'icon-storage-filled',
  service_network: 'icon-network-filled',
  service_voip: 'icon-voip-filled',
  service_other: 'icon-other-filled'
}
